// API Configuration
export const API_CONFIG = {
  // Base URL for the API - you can modify this based on your backend URL
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',

  // API Endpoints
  ENDPOINTS: {
    AUTH: {
      REQUEST_OTP: '/admin/auth/login-email-otp',
      VERIFY_OTP: '/admin/auth/verify-otp',
    },
    FIRMS: {
      LIST: '/admin/pricing/firms',
      DETAIL: '/admin/pricing/firms',
      UPDATE_PLAN_CONFIG: '/admin/pricing/firms',
    },
  },

  // Request timeout in milliseconds
  TIMEOUT: 30000,
} as const;
